const breakpoints = {
  mobile: 320,
  tablet: 768,
  desktop: 1024,
}

export default breakpoints
